module.exports = __webpack_public_path__ + "img/1372.13ba079f.gif";